import { clientsMessages } from "../../features/Clients/messages";
import { gray50 } from "../../theme";
import { useMsg } from "../Msg/Msg";
import { StyledTableCell, StyledTableRow } from "../Table";
import { H2 } from "../Typography";
import { ScheduledSession } from "./ScheduledSession";

export const ScheduledSessions = ({ name, data, type, firstRowExtraInfo }) => {
  const msg = useMsg({ dict: clientsMessages });

  return (
    <>
      <H2 sx={{ fontSize: "16px" }}>
        {name
          ? msg("clients.upcoming.with-name", { name })
          : msg("clients.upcoming.all-sessions")}
      </H2>
      {data.map((session, i) => (
        <ScheduledSession
          key={session.time + session.username}
          data={session}
          type={type}
          extraInfo={i === 0 ? firstRowExtraInfo : undefined}
        />
      ))}
    </>
  );
};

export const ScheduledSessionsTableRow = ({
  data,
  columns,
  colSpan = columns.length,
  name,
  type, // "coach" || "user"
  firstRowExtraInfo,
  sx = {},
}) => {
  if (!data?.length) return null;

  return (
    <StyledTableRow
      sx={{ bgcolor: gray50, ...sx }}
      //   sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <StyledTableCell colSpan={colSpan} variant="default">
        <ScheduledSessions {...{ name, data, type, firstRowExtraInfo }} />
      </StyledTableCell>
    </StyledTableRow>
  );
};
